import { commonConstants } from '../_constants';
import { ratesEffect } from '../_effects';

export const ratesActions = {
  getRates,
  rateCharges,
  getCurrencyCalc,
  clearRatesData,
  clearCalCur,
};

function clearRatesData() {
  return (dispatch) => {
    dispatch(clearRates());
  };
}

function clearRates() {
  return { type: commonConstants.CLEAR_RATE, payload: null };
}

function getRates(rates) {
  return (dispatch) => {
    dispatch(request(rates));
    ratesEffect.getRate(rates).then(
      (rates) => {
        dispatch(success(rates));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(rates) {
    return { type: commonConstants.RATES_REQUEST, rates };
  }
  function success(rates) {
    return { type: commonConstants.RATES_SUCCESS, rates };
  }
  function failure(error) {
    return { type: commonConstants.RATES_FAILURE, error };
  }
}

function rateCharges(ratecharges) {
  return (dispatch) => {
    dispatch(request(ratecharges));
    ratesEffect.getRateCharge(ratecharges).then(
      (ratecharges) => {
        dispatch(success(ratecharges));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(ratecharges) {
    return { type: commonConstants.GET_RATE_CHARGE_REQUEST, ratecharges };
  }
  function success(ratecharges) {
    return { type: commonConstants.GET_RATE_CHARGE_SUCCESS, ratecharges };
  }
  function failure(error) {
    return { type: commonConstants.GET_RATE_CHARGE_FAILURE, error };
  }
}

function clearCalCur() {
  return (dispatch) => {
    dispatch(clearCurr());
  };
}

function clearCurr() {
  return { type: commonConstants.CLEAR_CALC_CURR, payload: null };
}

function getCurrencyCalc(currencyCalc) {
  return (dispatch) => {
    dispatch(request(currencyCalc));
    ratesEffect.getCurrencyCalc(currencyCalc).then(
      (currencyCalc) => {
        dispatch(success(currencyCalc));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(currencyCalc) {
    return { type: commonConstants.CURRENCTY_CAL_REQUEST, currencyCalc };
  }
  function success(currencyCalc) {
    return { type: commonConstants.CURRENCTY_CAL_SUCCESS, currencyCalc };
  }
  function failure(error) {
    return { type: commonConstants.CURRENCTY_CAL_FAILURE, error };
  }
}
